import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Helmet } from 'react-helmet-async';
import BookingForm from '../components/BookingForm';
import './MusicianProfile.css';

export default function StudioProfile() {
  const { id } = useParams();
  const [studio, setStudio] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudio = async () => {
      const docRef = doc(db, 'studios', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setStudio({ id: docSnap.id, ...docSnap.data() });
      }
    };
    fetchStudio();
  }, [id]);

  if (!studio) {
    return <p style={{ color: 'white', textAlign: 'center' }}>Chargement...</p>;
  }

  return (
    <div className="musician-profile-container animated-fade-in">
      <Helmet>
        <title>{`${studio.name} | Studio d'enregistrement`}</title>
        <meta
          name="description"
          content={`Découvrez le studio ${studio.name} situé à ${studio.city}. ${studio.description || ''}`}
        />
        <meta property="og:title" content={`${studio.name} | Studio d'enregistrement`} />
        <meta
          property="og:description"
          content={`Studio d'enregistrement ${studio.name}, situé à ${studio.city}.`}
        />
        {studio.imageURL && <meta property="og:image" content={studio.imageURL} />}
        <link rel="canonical" href={`https://www.gatesofmusic.com/studios/${studio.id}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://www.gatesofmusic.com/studios/${studio.id}`} />
      </Helmet>

      <div className="musician-profile-card">
        <img
          src={studio.imageURL ? `/images/studios/${studio.imageURL}` : '/default-studio.png'}
          alt={studio.name}
          className="musician-profile-image"
        />
        <div className="musician-profile-info">
          <h1 className="musician-profile-name">{studio.name}</h1>
          <p><strong>Ville :</strong> {studio.city}</p>

          {studio.description && (
            <div className="musician-profile-bio-block">
              <h3 className="musician-profile-bio-title">Description</h3>
              <p className="musician-profile-bio-text">{studio.description}</p>
            </div>
          )}

          {studio.contact && (
            <div className="musician-profile-bio-block">
              <h3 className="musician-profile-bio-title">Contact</h3>
              <p className="musician-profile-bio-text">{studio.contact}</p>
            </div>
          )}
        </div>
      </div>

      <div className="musician-profile-bottom">
        <BookingForm entityId={studio.id} entityName={studio.name} />
        <button
          className="musician-profile-back-button"
          onClick={() => navigate('/')}
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}
